// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","lds_roller":"Loader_lds_roller__Owfol"};